export default __webpack_public_path__ + "static/smellsLikePancake-5464260de41d45cbff63143d1ca6fd23.png";